import {
  CollaborationPhaseSectionProps,
  RealityImageContentCardSectionProps,
  SvgIcon,
  TextColumnsSectionProps,
  TextSectionProps,
} from '@brick/ui-components';
import alphabetIcon from '../assets/icons/alphabet.svg';
import briefcaseIcon from '../assets/icons/briefcase-white.svg';
import ideaIcon from '../assets/icons/idea.svg';

export const collaborationPhaseSectionContent: CollaborationPhaseSectionProps =
  {
    title: 'PRVÁ FÁZA SPOLUPRÁCE',
    timelineItems: [
      {
        title: 'Osobné stretnutie s majiteľom',
        description:
          'Na osobnom stretnutí nám klient špecifikuje svoje dôvody a potreby ohľadom predaja / prenájmu.',
        icon: <SvgIcon src={briefcaseIcon} />,
      },
      {
        title: 'Osobné stretnutie s majiteľom',
        description:
          'Na osobnom stretnutí nám klient špecifikuje svoje dôvody a potreby ohľadom predaja / prenájmu.',
        icon: <SvgIcon src={briefcaseIcon} />,
      },
      {
        title: 'Osobné stretnutie s majiteľom',
        description:
          'Na osobnom stretnutí nám klient špecifikuje svoje dôvody a potreby ohľadom predaja / prenájmu.',
        icon: <SvgIcon src={briefcaseIcon} />,
      },
    ],
    content: `
Realitná služba je žiaľ častokrát vnímaná ako služba bez pridanej hodnoty. Predáva sa tá istá nehnuteľnosť cez viaceré realitné kancelárie, z ktorých si každá nahodí vlastnú cenu pričom používa fotky od majiteľov. V mnohých prípadoch vidí maklér majiteľa a jeho nehnuteľnosť prvý raz až s prvým kupujúcim.

V BRICK reality pristupujeme k realitnej službe zodpovedne a každá naša spolupráca sa začína osobným stretnutím s majiteľom nehnuteľnosti. Aby sme pracovali v prospech predávajúceho, musíme:
- spoznať jeho potreby a dôvody na predaj
- spoznať nehnuteľnosť, jej prednosti aj nedostatky
- odprezentovať náš spôsob práce

Dobrá príprava je kľúčom k rýchlemu a úspešnému predaju. Následné odporúčanie našich služieb je zrkadlom spokojnosti predávajúcich s našimi službami.
    `,
  };

export const sellPageTextContent: TextSectionProps = {
  textWithHeading: {
    heading: {
      title: 'REALITA PRI PREDAJI / PRENÁJME NEHNUTEĽNOSTI',
    },
    content: `Zvažujete predaj, prenájom alebo kúpu nehnuteľnosti? Vyžadujete služby na profesionálnej úrovni, odbornosť a individuálny prístup? Vitajte v BRICK reality. Nadštandardný realitný servis, ktorý Vám ušetrí Váš čas a finančné prostriedky.`,
    color: 'grey.500',
  },
};

export const sellPageTextColumnsSection: TextColumnsSectionProps = {
  columns: [
    {
      heading: {
        title: 'CHCETE PREDAŤ?',
        pb: 1,
      },
      content: `
## Prečo predať cez BRICK reality?
<br>

Ceníme si každého klienta a prispôsobujeme naše odborné služby jeho potrebám. Nie je umenie predať rýchlo, ale rýchlo, bezpečne a za čo najvyššiu cenu.
<br>
- V prvom rade pracujeme pre predávajúceho
- Prvý kupujúci neznamená ten najvhodnejší
- Organizované obhliadky šetriace čas predávajúceho

## Možná licitácia Vašej nehnuteľnosti
<br>
Komu chcete predať? Prvému záujemcovi, alebo tomu, ktorý chce zaplatiť najviac? My nie sme bežná realitka, ktorá sa uspokojí s priemerom. My vyšťavíme z trhu maximum a pri viacerých vážnych záujemcoch sa licitáciou cena navyšuje.
  `,
    },
    {
      heading: {
        title: 'CHCETE PRENAJAŤ?',
      },
      content: `
## Prečo prenajať cez BRICK reality?
<br>

Nie je umenie prenajať, ale nájsť správneho nájomcu, aby sa nehnuteľnosť neznehodnotila. Celý proces správneho výberu zabezpečujeme v prospech majiteľov nehnuteľnosti.
<br>

- V prvom rade pracujeme pre prenajímateľa
- Správny výber nájomcov
- Právna rovnováha zmluvných strán

## Vyberieme Vám tých správnych nájomníkov
<br>
Našou úlohou je popasovať sa s požiadavkami majiteľov nehnuteľnosti. Nájdeme takých nájomníkov, aby nielen na začiatku nájomného vzťahu spĺňali kritéria majiteľov, ale aby na nich majiteľ vždy v dobrom spomínal.
  `,
    },
  ],
};

export const realityImageContentCardSectionContent: RealityImageContentCardSectionProps =
  {
    heading: {
      title: 'V MORI NEHNUTEĽNOSTÍ VÁM NÁJDEME DOMOV',
      description:
        'Pri kúpe nehnuteľnosti sú financie dôležitou súčasťou celého procesu výberu a kúpy Vášho nového bývania. V BRICK reality Vám zabezpečíme všetko pod jednou strechou tak, aby sme za Vás vyjednali tie najlepšie aktuálne podmienky na trhu.',
    },
    image: '/other/flat.png',
    fullParagraphs: [
      {
        title: 'Vyberieme pre Vás relevantné ponuky',
        iconText: {
          icon: <SvgIcon src={alphabetIcon} size={48} />,
          text: 'Plánujete chodiť od jednej k druhej a tak strácať svoj čas? Máte pár minút na obhliadku a skutočný stav uvidíte až po prebratí nehnuteľnosti?',
        },
        description: 'Zverte sa do rúk odborníkov, ktorí pracujú pre Vás.',
        listItems: [
          'Bezplatná konzultácia s našim odborníkom',
          'Nájdeme, skontrolujeme, odsúhlasíme a právne zabezpečíme',
        ],
      },
      {
        title: 'Preveríme právny stav nehnuteľnosti',
        iconText: {
          icon: <SvgIcon src={ideaIcon} size={48} />,
          text: 'U Vás je to raz za život, my to zvládame na dennej báze. Veľakrát vybavíme zľavu z nehnuteľnosti.',
        },
        description:
          'V niektorých prípadoch je cena nehnuteľnosti prestrelená. Na to sme tu MY, aby sme za Vás vyjednali tie najlepšie podmienky.',
        listItems: [
          'Odborník Vás zastupuje a tlačí cenu dolu',
          'Právna podpora zmluvnej dokumentácie',
        ],
      },
    ],
  };
